export const associationHero = {
  title: '全日本執事協会について',
  titleEn: 'THE ASSOCIATION',
  lead: '日本執事アカデミーは、一般社団法人全日本執事協会が運営しています。',
};

export const associationRoleParagraphs = [
  '日本執事アカデミーの運営母体は、一般社団法人全日本執事協会です。協会は、執事の育成と認定、そして企業向けの研修を通じて、日本における執事文化の確立に取り組んでいます。',
  '協会の活動は、単に執事を養成するだけではありません。育成した人材の質を保証する認定資格の発行、執事の接遇スキルを企業の現場に活かす法人研修の提供、そして修了生のキャリア形成を支援する仕組みの整備——これらを一貫して担うことで、執事という職業の社会的な価値を高めることを目指しています。',
  'なお、法人研修で提供するのは執事の接遇スキルに基づくビジネスマナー教育であり、企業の受講者に執事資格を付与するものではありません。本科課程の協会認定資格とは区別してご理解ください。今後の事業展開については、検討が整い次第、順次公開してまいります。',
];

export const associationServices = [
  {
    icon: 'ri-school-line',
    title: '執事育成（本科3コース）',
    description:
      'エッセンシャル・アドバンス・マスターの3段階で、基礎から管理・危機対応までを体系立てて指導します。定員6名の完全少人数制・土日開催。',
    href: '/courses',
  },
  {
    icon: 'ri-award-line',
    title: '協会認定資格の認定',
    description:
      '所定の課程を修了し、実技試験に合格した方に、全日本執事協会認定のバトラー資格を授与します。協会が定める基準に達した証です。',
    href: '/certificate',
  },
  {
    icon: 'ri-building-2-line',
    title: '法人研修（接遇・ビジネスマナー）',
    description:
      '執事の接遇スキルに基づく法人向け研修を提供します。出張または来校にて、貴社の現場に合わせたプログラムを設計します。',
    href: '/corporate',
  },
  {
    icon: 'ri-briefcase-line',
    title: '修了生へのキャリア支援（準備中）',
    description:
      '修了生の方へ、協会が把握した執事関連の求人情報を提供する仕組みを予定しています。キャリア形成の選択肢のひとつとしてご活用いただけるよう準備を進めています。',
    href: '/career',
  },
];

export const associationInfo = [
  { label: '名称', value: '一般社団法人全日本執事協会' },
  { label: '所在地', value: '〒135-0064 東京都江東区青海2丁目7-4（お台場）' },
  { label: '電話', value: '03-6824-4086（受付 平日10:00〜17:00）' },
  { label: 'メール', value: 'info@butler-academy.jp' },
  { label: '事業内容', value: '執事の育成、認定資格の認定、法人研修、修了生向けキャリア支援（準備中）' },
  { label: '代表者', value: '※準備中（順次公開）' },
];

export const associationFaqs = [
  {
    question: '協会は何をしている団体ですか？',
    answer:
      '執事の育成（本アカデミーの運営）、協会認定資格の認定、企業向けの接遇・ビジネスマナー研修、修了生向けキャリア支援（準備中）を行っています。',
  },
  {
    question: '認定資格は国家資格ですか？',
    answer:
      'いいえ。協会が独自に認定する民間資格です。修了実技試験の合格者に授与しています。',
  },
  {
    question: '法人向けの研修も依頼できますか？',
    answer:
      'はい。執事の接遇スキルに基づくビジネスマナー研修を、出張・来校いずれの形式でも承っています。法人研修のページをご覧ください。',
  },
];

export const associationRelatedPages = [
  {
    title: 'アカデミーについて',
    description: 'アカデミーの全体像',
    href: '/about',
  },
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: '法人研修',
    description: '企業向けの接遇・ビジネスマナー研修',
    href: '/corporate',
  },
  {
    title: 'お問い合わせ',
    description: 'ご質問・ご相談の窓口',
    href: '/contact',
  },
  {
    title: '学長挨拶',
    description: '学長・執事ベルからのメッセージ',
    href: '/president',
  },
  {
    title: '全日本執事協会 事業紹介',
    description: '協会が提供する事業の詳しいご紹介',
    href: '/related/butler-association',
  },
];